import { useDispatch, useSelector } from 'react-redux';
import { Alert, Snackbar, Button, createTheme, ThemeProvider, StyledEngineProvider } from '@mui/material';
import { closeSnackbar } from './snackbarSlice';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createInteraction } from '../../shared/requests/interactionsRequsts';
import { createService } from '../../shared/requests/serviceNetworkRequests';
import { createEngagement } from '../../shared/requests/engagementsRequest';

const theme = createTheme({
  components: {
    MuiAlert: {
      styleOverrides: {
        standardSuccess: {
          backgroundColor: 'green',
          color: 'white',
        },
        // standardError: {
        //   backgroundColor: 'red',
        //   color: 'white',
        // },
        standardWarning: {
          backgroundColor: 'goldenrod',
          color: 'white',
        },
        // standardInfo: {
        //   backgroundColor: 'blue',
        //   color: 'white',
        // },
      },
    },
  },
});

export default function AppSnackbar() {
  const queryClient = useQueryClient();

  const undoDeleteServiceMutation = useMutation({
    mutationFn: (payload) => {
      const { _id, createdAt, updatedAt, __v, tenant, file, linkedInteraction, linkedEngagement, ...rest } = payload;
      const normalizedPayload = {
        ...rest,
        linkedInteraction: (linkedInteraction || []).map((i) => (typeof i === 'object' ? i._id || i : i)),
        linkedEngagement: (linkedEngagement || []).map((e) => (typeof e === 'object' ? e._id || e : e)),
        file: [],
      };
      return createService(normalizedPayload);
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['monthlyServices'] }),
  });
  const undoDeleteInteractionMutation = useMutation({
    mutationFn: (payload) => createInteraction(payload),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['monthlyIssues'] }),
  });
  const undoDeleteEngagementMutation = useMutation({
    mutationFn: (payload) => createEngagement(payload),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['monthlyEngagements'] }),
  });

  const eventMap = {
    deleteIssue: { label: 'UNDO', callback: (payload) => undoDeleteInteractionMutation.mutate(payload) },
    deleteService: { label: 'UNDO', callback: (payload) => undoDeleteServiceMutation.mutate(payload) },
    deleteEngagement: { label: 'UNDO', callback: (payload) => undoDeleteEngagementMutation.mutate(payload) },
  };
  const severities = ['info', 'warning', 'alert', 'success', 'error'];

  const dispatch = useDispatch();
  const { isOpen, message, severity, callbackData, eventType } = useSelector((state) => state.snackbar);

  const handleClose = (reason) => {
    if ('clickaway' === reason) return;

    dispatch(closeSnackbar());
  };

  const handleCallback = () => {
    try {
      eventMap[eventType]['callback'](callbackData);
    } catch (e) {
      alert('callback failed - ' + e);
    }
  };

  let label = null;
  if (eventMap.hasOwnProperty(eventType)) {
    label = eventMap[eventType]['label'];
  }

  let alertSeverity = 'info';
  if (severities.indexOf(severity) > -1) {
    alertSeverity = severity;
  } else {
    console.log('invalid severity provided');
  }

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          open={isOpen}
          autoHideDuration={6000}
          onClose={handleClose}
          message={message}
        >
          <Alert onClose={handleClose} severity={alertSeverity}>
            {message}
            {label ? (
              <Button color="secondary" size="small" onClick={handleCallback}>
                {label}
              </Button>
            ) : (
              <></>
            )}
          </Alert>
        </Snackbar>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
